import { useEffect, useRef, useState } from "react";

export interface TruncatedTextHookResult {
  textRef: React.RefObject<HTMLSpanElement>;
  isTruncated: boolean;
}

export function useTruncatedText(text: string): TruncatedTextHookResult {
  const textRef = useRef<HTMLSpanElement>(null);
  const [isTruncated, setIsTruncated] = useState(false);

  useEffect(() => {
    const checkTruncation = () => {
      if (textRef.current) {
        setIsTruncated(textRef.current.scrollWidth > textRef.current.clientWidth);
      }
    };

    checkTruncation();
    window.addEventListener("resize", checkTruncation);

    return () => {
      window.removeEventListener("resize", checkTruncation);
    };
  }, [text]);

  return {
    textRef,
    isTruncated
  };
}

